"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedHost = void 0;
const web_env_1 = require("@snapchat/web-env");
// don't do exposure logging for localhost, browserstack etc
const DISABLED_HOSTS = ["localhost", "mesh.sc-corp", "bs-local.com"];
function isAllowedHost() {
    if (DISABLED_HOSTS.some((host) => window.document.location.host.includes(host))) {
        return false;
    }
    return !(0, web_env_1.isRunningOnServer)();
}
exports.isAllowedHost = isAllowedHost;
//# sourceMappingURL=hosts.js.map